/** Ein kurzer, nutzbarer Starttext; dieselbe Grenze im Wizard und in der Checkliste. */
export const MIN_PROJECT_DESCRIPTION_LENGTH = 60;
/**
 * Wofür ein hochgeladenes Bild steht.
 *
 * Die Beschreibung sagt, was auf dem Bild ist; die Rolle sagt in einem Wort,
 * welchen Platz es in einer Geschichte hat. Der Planer bekommt beides und
 * findet damit den passenden Screen schneller als aus dem Freitext allein.
 * `hidden` nimmt ein Bild ganz aus der Auswahl, ohne es zu löschen -- etwa
 * eine Einstellungsseite, die man hochgeladen hat, aber nie zeigen will.
 */
export const REFERENCE_ROLES = [
    { key: 'home', label: 'Startseite', hint: 'der erste Eindruck' },
    { key: 'core', label: 'Kernfunktion', hint: 'das, wofür man es benutzt' },
    { key: 'success', label: 'Erfolg', hint: 'der Moment, in dem es sich gelohnt hat' },
    { key: 'onboarding', label: 'Einstieg', hint: 'Anmelden, erste Schritte' },
    { key: 'hidden', label: 'Nicht zeigen', hint: 'wird nie in einem Beitrag verwendet' },
];
export function referenceRoleLabel(role) {
    return REFERENCE_ROLES.find((r) => r.key === role)?.label ?? '';
}
//# sourceMappingURL=project.js.map